"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Survey = /*#__PURE__*/function () {
  function Survey(client) {
    (0, _classCallCheck2["default"])(this, Survey);
    this.client = client;
    this.resourceUrl = '/survey';
  }

  (0, _createClass2["default"])(Survey, [{
    key: "getSurveys",
    value: function getSurveys(type, filterBy) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      // personal-detail dynamic
      return this.client.get("".concat(this.resourceUrl, "/").concat(type, "-detail").concat(filterBy ? "?filterBy=".concat(filterBy) : ''), args);
    }
  }, {
    key: "getSurveyById",
    value: function getSurveyById(id, surveyType) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(id).concat(surveyType ? "?surveyType=".concat(surveyType) : ''), args);
    }
  }, {
    key: "getSurveyByCompany",
    value: function getSurveyByCompany(company, params) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return this.client.get("".concat(this.resourceUrl, "/company/").concat(company).concat(params), args);
    }
  }, {
    key: "getSurveyByTeam",
    value: function getSurveyByTeam(company, team, params) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
        args[_key4 - 3] = arguments[_key4];
      }

      return this.client.get("".concat(this.resourceUrl, "/company/").concat(company, "/team/").concat(team).concat(params), args);
    }
  }, {
    key: "getSurveyByEcosystem",
    value: function getSurveyByEcosystem(affiliation, params) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return this.client.get("".concat(this.resourceUrl, "/ecosystem/").concat(affiliation).concat(params), args);
    }
  }, {
    key: "getSurveyByGroup",
    value: function getSurveyByGroup(groupId, params) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      return this.client.get("".concat(this.resourceUrl, "/team/").concat(groupId, "/report").concat(params), args);
    }
  }, {
    key: "getComparisonReport",
    value: function getComparisonReport(params) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      return this.client.get("".concat(this.resourceUrl, "/comparison-report").concat(params), args);
    }
  }, {
    key: "getCompanyComparisonReport",
    value: function getCompanyComparisonReport(params) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      return this.client.get("".concat(this.resourceUrl, "/organization-comparison-report").concat(params), args);
    }
  }, {
    key: "getTeamComparisonReport",
    value: function getTeamComparisonReport(params) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return this.client.get("".concat(this.resourceUrl, "/organization-team-comparison-report").concat(params), args);
    }
  }, {
    key: "getAffiliationComparisonReport",
    value: function getAffiliationComparisonReport(params) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }

      return this.client.get("".concat(this.resourceUrl, "/network-comparison-report").concat(params), args);
    }
  }, {
    key: "getGroupComparisonReport",
    value: function getGroupComparisonReport(teamId, params) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 2 ? _len11 - 2 : 0), _key11 = 2; _key11 < _len11; _key11++) {
        args[_key11 - 2] = arguments[_key11];
      }

      return this.client.get("".concat(this.resourceUrl, "/team/").concat(teamId, "/comparison").concat(params), args);
    }
  }, {
    key: "getCategory",
    value: function getCategory(category) {
      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }

      return this.client.get("".concat(this.resourceUrl, "/category/").concat(category), args);
    }
  }, {
    key: "getCountByCompany",
    value: function getCountByCompany(surveyType, companyName, teamName, startDate, endDate) {
      var URL = "".concat(this.resourceUrl, "/count-by-company");

      if (surveyType === 'team') {
        URL += "-team";
      }

      URL += "?company=".concat(companyName);

      if (surveyType === 'team') {
        URL += "&teamName=".concat(teamName);
      }

      URL += "&startDate=".concat(startDate, "&endDate=").concat(endDate);

      for (var _len13 = arguments.length, args = new Array(_len13 > 5 ? _len13 - 5 : 0), _key13 = 5; _key13 < _len13; _key13++) {
        args[_key13 - 5] = arguments[_key13];
      }

      return this.client.get(URL, args);
    }
  }, {
    key: "getCountByAffiliation",
    value: function getCountByAffiliation(params) {
      for (var _len14 = arguments.length, args = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
        args[_key14 - 1] = arguments[_key14];
      }

      return this.client.get("".concat(this.resourceUrl, "/count-by-ecosystem").concat(params), args);
    }
  }, {
    key: "getCountByGroup",
    value: function getCountByGroup(teamId, params) {
      for (var _len15 = arguments.length, args = new Array(_len15 > 2 ? _len15 - 2 : 0), _key15 = 2; _key15 < _len15; _key15++) {
        args[_key15 - 2] = arguments[_key15];
      }

      return this.client.get("".concat(this.resourceUrl, "/team/").concat(teamId, "/count").concat(params), args);
    }
  }, {
    key: "getLink",
    value: function getLink(type) {
      for (var _len16 = arguments.length, args = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
        args[_key16 - 1] = arguments[_key16];
      }

      return this.client.get("".concat(this.resourceUrl, "/link").concat(type ? "?type=".concat(type) : ''), args);
    }
  }, {
    key: "getRequestedUsers",
    value: function getRequestedUsers(type) {
      for (var _len17 = arguments.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
        args[_key17 - 1] = arguments[_key17];
      }

      return this.client.get("".concat(this.resourceUrl, "-request"), args);
    }
  }, {
    key: "sendRequestedUsers",
    value: function sendRequestedUsers(data) {
      for (var _len18 = arguments.length, args = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
        args[_key18 - 1] = arguments[_key18];
      }

      return this.client.post("".concat(this.resourceUrl, "-request"), data, args);
    }
  }, {
    key: "getTypeFormLink",
    value: function getTypeFormLink(surveyRequestId) {
      for (var _len19 = arguments.length, args = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
        args[_key19 - 1] = arguments[_key19];
      }

      return this.client.get("".concat(this.resourceUrl, "-request/typeform/").concat(surveyRequestId), args);
    }
  }, {
    key: "getEmailBySurveyRequestId",
    value: function getEmailBySurveyRequestId(surveyRequestId) {
      for (var _len20 = arguments.length, args = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
        args[_key20 - 1] = arguments[_key20];
      }

      return this.client.get("".concat(this.resourceUrl, "-request/").concat(surveyRequestId), args);
    }
  }, {
    key: "getLeaderRequests",
    value: function getLeaderRequests(groupId) {
      var url = '';

      if (groupId) {
        url = "".concat(this.resourceUrl, "-request/leader/").concat(groupId);
      } else {
        url = "".concat(this.resourceUrl, "-request/leader");
      }

      for (var _len21 = arguments.length, args = new Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
        args[_key21 - 1] = arguments[_key21];
      }

      return this.client.get("".concat(url), args);
    }
  }, {
    key: "getLeaderAssessmentResult",
    value: function getLeaderAssessmentResult(userId, requestId) {
      for (var _len22 = arguments.length, args = new Array(_len22 > 2 ? _len22 - 2 : 0), _key22 = 2; _key22 < _len22; _key22++) {
        args[_key22 - 2] = arguments[_key22];
      }

      return this.client.get("".concat(this.resourceUrl, "-request/leader-survey/").concat(userId, "/").concat(requestId), args);
    }
  }, {
    key: "newLeaderRequests",
    value: function newLeaderRequests(data) {
      for (var _len23 = arguments.length, args = new Array(_len23 > 1 ? _len23 - 1 : 0), _key23 = 1; _key23 < _len23; _key23++) {
        args[_key23 - 1] = arguments[_key23];
      }

      return this.client.post("".concat(this.resourceUrl, "-request/leader"), data, args);
    }
  }, {
    key: "updateLeaderRequests",
    value: function updateLeaderRequests(id, data) {
      for (var _len24 = arguments.length, args = new Array(_len24 > 2 ? _len24 - 2 : 0), _key24 = 2; _key24 < _len24; _key24++) {
        args[_key24 - 2] = arguments[_key24];
      }

      return this.client.put("".concat(this.resourceUrl, "-request/leader/").concat(id), data, args);
    }
  }, {
    key: "getLeaderAndAwarenessAssessments",
    value: function getLeaderAndAwarenessAssessments(userId) {
      for (var _len25 = arguments.length, args = new Array(_len25 > 1 ? _len25 - 1 : 0), _key25 = 1; _key25 < _len25; _key25++) {
        args[_key25 - 1] = arguments[_key25];
      }

      return this.client.get("".concat(this.resourceUrl, "/awareness-and-leader/").concat(userId), args);
    }
  }, {
    key: "getSurveyRequestForm",
    value: function getSurveyRequestForm(type, request, token) {
      var _this$client;

      var queryParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var query = new URLSearchParams(queryParams).toString();
      var url = "".concat(this.resourceUrl, "-request/").concat(type, "/").concat(request, "/").concat(token).concat(query ? "?".concat(query) : '');

      for (var _len26 = arguments.length, args = new Array(_len26 > 4 ? _len26 - 4 : 0), _key26 = 4; _key26 < _len26; _key26++) {
        args[_key26 - 4] = arguments[_key26];
      }

      return (_this$client = this.client).get.apply(_this$client, [url].concat(args));
    }
  }, {
    key: "sendReminderForS360",
    value: function sendReminderForS360() {
      for (var _len27 = arguments.length, args = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
        args[_key27] = arguments[_key27];
      }

      return this.client.post("".concat(this.resourceUrl, "-request/resend-simple-360-email"), args);
    }
  }, {
    key: "sendReminderForLeader",
    value: function sendReminderForLeader(groupId) {
      for (var _len28 = arguments.length, args = new Array(_len28 > 1 ? _len28 - 1 : 0), _key28 = 1; _key28 < _len28; _key28++) {
        args[_key28 - 1] = arguments[_key28];
      }

      return this.client.post("".concat(this.resourceUrl, "-request/leader/").concat(groupId, "/resend-email"), args);
    }
  }]);
  return Survey;
}();

exports["default"] = Survey;